function getScoreColor(score=0, colors={}) {
  if (!score || !colors) return colors.neutral;
  return score > 0 ? colors.success : colors.warn;
}

export { getScoreColor };
